export const projects = [
  {
    id: 'warm-hospitality',
    translationKey: 'warmHospitality',
    mainImage: '/images/projects/project7/1.jpg',
    gallery: [
      '/images/projects/project7/2.jpg',
      '/images/projects/project7/3.jpg',
      '/images/projects/project7/4.jpg',
      '/images/projects/project7/5.jpg',
      '/images/projects/project7/6.jpg',
      '/images/projects/project7/7.jpg',
    ],
  },
  {
    id: 'modern-elegance',
    translationKey: 'modernElegance',
    mainImage: '/images/projects/project6/1.png',
    gallery: [
      '/images/projects/project6/2.png',
      '/images/projects/project6/3.png',
      '/images/projects/project6/4.png',
      '/images/projects/project6/5.png',
    ],
  },
  {
    id: 'modern-classic',
    translationKey: 'modernClassic',
    mainImage: '/images/projects/project1/livingroom.jpg',
    gallery: [
      '/images/projects/project1/kitchen.jpg',
      '/images/projects/project1/bedroom.jpg',
      '/images/projects/project1/diningroom.jpg',
      '/images/projects/project1/livingroom2.jpg',
    ],
  },
  {
    id: 'rustic-style',
    translationKey: 'rusticStyle',
    mainImage: '/images/projects/project3/livingroom1.jpg',
    gallery: [
      '/images/projects/project3/kitchen.jpg',
      '/images/projects/project3/bedroom.jpg',
      '/images/projects/project3/bathroom.jpg',
      '/images/projects/project3/entrance.jpg',
    ],
  },
  {
    id: 'blue-summer-caravan',
    translationKey: 'blueSummerCaravan',
    mainImage: '/images/projects/project2/1.jpg',
    gallery: [
      '/images/projects/project2/2.jpg',
      '/images/projects/project2/3.jpg',
      '/images/projects/project2/4.jpg',
      '/images/projects/project2/5.jpg',
      '/images/projects/project2/6.jpg',
    ],
  },
  {
    id: 'pastel-harmony',
    translationKey: 'pastelHarmony',
    mainImage: '/images/projects/project4/livingroom.jpg',
    gallery: [
      '/images/projects/project4/livingroom2.jpg',
      '/images/projects/project4/kitchen.jpg',
      '/images/projects/project4/bedroom.jpg',
    ],
  },
  {
    id: 'serene-bedroom',
    translationKey: 'sereneBedroom',
    mainImage: '/images/projects/project5/1.jpg',
    gallery: [
      '/images/projects/project5/2.jpg',
      '/images/projects/project5/3.jpg',
      '/images/projects/project5/4.jpg',
      '/images/projects/project5/5.jpg',
    ],
  }
];
